import React, { useCallback } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, Line, LineChart, ComposedChart } from 'recharts';
//import {CustomXaxis} from './customXaxis'
import { Row, Col, OverlayTrigger, Tooltip as BSTooltip } from 'react-bootstrap';
import { useCurrentPng } from 'recharts-to-png';
import FileSaver from "file-saver";
import { FaDownload, FaInfoCircle } from 'react-icons/fa';
// import { ModalTimeseriesSelection } from './modalTimeseriesSelection'

const InfoIcon = ({text}) => {
    return (
      <OverlayTrigger
          placement="bottom"
          overlay={
            <BSTooltip>
              {text}
            </BSTooltip>
          }
        >
          <span>
            <FaInfoCircle />
          </span>
        </OverlayTrigger>
    )
}


export const TimeSeriesCharts = ({ overallData, overallFueltypes, fuelTypeInfo, charts, setCharts }) => {

  // const getConsumptionData = (d) => {
  //   const substring = 'consumption'
  //   let fdata = d.map(d => {
  //     let e = Object.keys(d).filter(key => key.includes(substring))
  //       .reduce((obj, key) => {
  //         return {
  //           ...obj,
  //           [key]: d[key]
  //         };
  //       }, {});
  //     e.name = d.year
  //     return e

  //   })
  //   return fdata
  // }

  //const 



  const [getConsumptionPNG, { ref: consumptionRef }] = useCurrentPng();
  const handleConsumptionDownload = useCallback(async () => {
    const png = await getConsumptionPNG();
    if (png) {
      FileSaver.saveAs(png, "consumption.png");
    }
  }, [getConsumptionPNG]);

  const [getCapacityPNG, { ref: capacityRef }] = useCurrentPng();
  const handleCapacityDownload = useCallback(async () => {
    const png = await getCapacityPNG({});
    if (png) {
      FileSaver.saveAs(png, "capacity.png");
    }
  }, [getCapacityPNG]);

  const [getShipsPNG, { ref: shipsRef }] = useCurrentPng();
  const handleShipsDownload = useCallback(async () => {
    const png = await getShipsPNG();
    if (png) {
      FileSaver.saveAs(png, "ships.png");
    }
  }, [getShipsPNG]);

  const [getPricePNG, { ref: priceRef }] = useCurrentPng();
  const handlePriceDownload = useCallback(async () => {
    const png = await getPricePNG();
    if (png) {
      FileSaver.saveAs(png, "price.png");
    }
  }, [getPricePNG]);

  const [getBunkerPNG, { ref: bunkerRef }] = useCurrentPng();
  const handleBunkerDownload = useCallback(async () => {
    const png = await getBunkerPNG();
    if (png) {
      FileSaver.saveAs(png, "bunker.png");
    }
  }, [getBunkerPNG]);

  const [getCapexPNG, { ref: capexRef }] = useCurrentPng();
  const handleCapexDownload = useCallback(async () => {
    const png = await getCapexPNG();
    if (png) {
      FileSaver.saveAs(png, "capex.png");
    }
  }, [getCapexPNG]);


  const [getOpexPNG, { ref: opexRef }] = useCurrentPng();
  const handleOpexDownload = useCallback(async () => {
    const png = await getOpexPNG();
    if (png) {
      FileSaver.saveAs(png, "opex.png");
    }
  }, [getOpexPNG]);


  const [getEmissionPNG, { ref: emissionRef }] = useCurrentPng();
  const handleEmissionDownload = useCallback(async () => {
    const png = await getEmissionPNG();
    if (png) {
      FileSaver.saveAs(png, "emission.png");
    }
  }, [getEmissionPNG]);

  
  const [getSpeedPNG, { ref: speedRef }] = useCurrentPng();
  const handleSpeedDownload = useCallback(async () => {
    const png = await getSpeedPNG();
    if (png) {
      FileSaver.saveAs(png, "speed.png");
    }
  }, [getSpeedPNG]);


  const [getElecPNG, { ref: elecRef }] = useCurrentPng();
  const handleElecDownload = useCallback(async () => {
    const png = await getElecPNG();
    if (png) {
      FileSaver.saveAs(png, "electric_energy.png");
    }
  }, [getElecPNG]);

  const getConsumptionData = (d) => {
    let fdata = d.map(f => { return { ...f.consumption, name: `${f.year}-${f.month}`  } })
    return fdata
  }

  const getFuelPriceData = (d) => {
    let fdata = d.map(f => { return { ...f.fuel_price, name: `${f.year}-${f.month}`  } })
    return fdata
  }

  const getOpexData = (d) => {
    let fdata = d.map(f => { return { OPEX: f.opex/1e6, 'Cumulative OPEX': f['opex_cumsum']/1e6, name: `${f.year}-${f.month}`  } })
    return fdata
  }

  const getEmissionData = (d) => {
    let fdata = d.map(f => { return ({ TankToWake: f['Tank-To-Wake'], WellToTank: f['Well-To-Tank'], Total: f['Tank-To-Wake'] + f['Well-To-Tank'], name: `${f.year}-${f.month}`  }) })
    return fdata
  }

  const getCapacityData = (d) => {
    let fdata = d.map(f => { return ({ Capacity: f['capacity_relative'], name: `${f.year}-${f.month}`  }) })
    return fdata
  }

  const getCapexData = (d) => {
    let fdata = d.map(f => { return ({ CAPEX: f['capex']/1e6, 'Cumulative CAPEX': f['capex_cumsum']/1e6, name: `${f.year}-${f.month}`  }) })
    return fdata
  }


  const getSailingShipData = (d) => {
    let fdata = d.map(f => { return ({ Ships: f['nships_relative'], name: `${f.year}-${f.month}` }) })
    return fdata
  }

  const getBunkeringShipData = (d) => {
    let fdata = d.map(f => { return ({ Ships: f['nbunkering_relative'], name: `${f.year}-${f.month}` }) })
    return fdata
  }

  const getSpeedData = (d) => {
    let fdata = d.map(f => { return ({ Speed: f['average_speed_kts'], name: `${f.year}-${f.month}` }) })
    return fdata
  }  
  
  const getElectricEnergyData = (d) => {
    let fdata = d.map(f => { return ({ 'Electric Energy': f['el_energy'], name: `${f.year}-${f.month}` }) })
    return fdata
  }

  // const getParams = (data, substring) => {
  //   let params = Object.keys(data[0]).filter(key => key.includes(substring))
  //   return params
  // }

  const getXticks = (d) => {
    const a = d.filter(a => (a.month - 1 < 0.1 && a.year % 5 === 0))
    .map(a => (`${a.year}-${a.month}`))
    return a

  }


  const CustomizedAxisTick = ({x, y, stroke, payload}) => {
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="middle" fill="#666">
          {payload.value.split("-")[0]}
        </text>
      </g>
        
    );
    
  }
  // tooltip
  const CustomTooltip = ({ active, payload, label, ...props }) => {
    
    if (active && payload && payload.length) {
      if (props.sort) {
        payload = payload.sort((a, b) => b.value - a.value)
      }
      return (
        <div style={{
          backgroundColor: 'white', border: '1px solid darkgray',
          borderRadius: '10px', padding: '10px'
        }}>
          <Row>
            <Col style={{ fontSize: 10 }}><b>{label}</b></Col>
          </Row>

          {payload.map((p, idx) =>
            <Row key={`tt${idx}`}>
              <Col style={{ fontSize: 10}}><span className="dot" style={{backgroundColor: p.color}}>&nbsp;</span> {`${p.name} : ${p.value.toFixed(2)}`}</Col>
            </Row>)
          }
        </div>
      );
    }
  }

  // tooltip for fuel
  const CustomTooltipFuel = ({ active, payload, label, ...props }) => {
    if (active && payload && payload.length) {
      const total = payload.map(p => p.value).reduce((a,b)=>a+b)
      return (
        <div style={{
          backgroundColor: 'white', border: '1px solid darkgray',
          borderRadius: '10px', padding: '10px'
        }}>
          <Row>
            <Col style={{ fontSize: 10 }}><b>{label}</b></Col>
          </Row>
          {payload.filter(p => p.value > 0).sort((a, b) => b.value - a.value).map((p, idx) =>
            <Row key={`ttfuel-${idx}`}>
              <Col style={{ fontSize: 10 }}><span className="dot" style={{backgroundColor: p.color}}>&nbsp;</span> {`${p.name} : ${p.value.toFixed(0)}`}</Col>
            </Row>)
          }
          <Row>
              <Col style={{ fontSize: 10 }}>{`Total: ${total.toFixed(0)}`}</Col>
            </Row>
        </div>
      );
    }
  }




  if (!!!overallFueltypes) return <div> loading</div>

  return (

    <div style={{ width: '100%' }}>
      {/* <ModalTimeseriesSelection charts={charts} setCharts={setCharts} /> */}

      {charts[0].checked ?
        <div>
          <div className='d-flex flex-row justify-content-between w-100 align-items-center'>
          <h6>Monthly fuel consumption [MWh]</h6>
          <FaDownload onClick={handleConsumptionDownload} style={{cursor: 'pointer'}}/>
          </div>

          <ResponsiveContainer width="100%" height={150}>

            <AreaChart
              data={getConsumptionData(overallData)}
              syncId="anyId"
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 5,
              }}
              ref={consumptionRef}
            >
              <CartesianGrid strokeDasharray="3 3" />
              {/* <XAxis hide= {true} /> */}
              {/* <CustomXaxis data={getConsumptionData(overallData)} xKey="name" y={16} /> */}
              <XAxis dataKey="name" ticks={getXticks(overallData)} tick={<CustomizedAxisTick />}/>
              <YAxis />

              {/* <Legend content={<CustomLegend customNames={overallFueltypes}/>} /> */}

              <Legend verticalAlign="top" align="right" height={36} />
              <Tooltip content={<CustomTooltipFuel/>} />
              {
                overallFueltypes.map(a => <Area key={a.name} dataKey={a.name} name={fuelTypeInfo[a.name].short_display_name} stackId="1"
                  stroke={fuelTypeInfo[a.name].color_name} fill={fuelTypeInfo[a.name].color_name} />)
              }
              {/* <Area type="monotone" dataKey="consumption_MDO" stackId="1" stroke="#8884d8" fill="#8884d8" />
          <Area type="monotone" dataKey="consumption_ELECTRICITY" stackId="1" stroke="red" fill="red" /> */}
            </AreaChart>
          </ResponsiveContainer>
        </div>
        :
        <div />
      }
      {charts[1].checked ?
        <div>
          <div className='d-flex flex-row justify-content-between w-100 align-items-center'>
          <h6>Monthly GHG emission [kTon CO2eq]</h6>
          <FaDownload onClick={handleEmissionDownload} style={{cursor: 'pointer'}}/>
          </div>
          <ResponsiveContainer width="100%" height={150}>

            <ComposedChart
              data={getEmissionData(overallData)}
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 5,
              }}
              syncId="anyId"
              ref={emissionRef}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" ticks={getXticks(overallData)} tick={<CustomizedAxisTick />}/>
              <YAxis />
              <Legend verticalAlign="center" align="right" height={36} />
              <Tooltip content={<CustomTooltip  date={"test"}/>} />
              <Area dataKey='WellToTank' stroke='gray' fill='gray' />
              <Area dataKey='TankToWake' stroke='darkgray' fill='darkgray' />
              <Line dataKey="Total" stroke="black" dot={false}/>
            </ComposedChart>
          </ResponsiveContainer>
        </div>
        :
        <div />
      }
      {charts[2].checked ?
        <div>
          <div className='d-flex flex-row justify-content-between w-100 align-items-center'>
          <h6>Monthly fuel price [Euro per kWh] </h6>
          <FaDownload onClick={handlePriceDownload} style={{cursor: 'pointer'}}/>
          </div>
          <ResponsiveContainer width="100%" height={150}>
            <LineChart
              data={getFuelPriceData(overallData)}
              syncId="anyId"
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 5,
              }}
              ref={priceRef}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" ticks={getXticks(overallData)} tick={<CustomizedAxisTick />}/>
              <YAxis />
              <Tooltip content={<CustomTooltip sort={true}/>} />
              {overallFueltypes.map(a => <Line key={`price_${a.name}`} dataKey={a.name} name={fuelTypeInfo[a.name].short_display_name} stroke={fuelTypeInfo[a.name].color_name} strokeWidth={2} dot={false} />)}

            </LineChart>
          </ResponsiveContainer>
        </div>
        :
        <div />
      }
      {charts[3].checked ?
        <div>
          <div className='d-flex flex-row justify-content-between w-100 align-items-center'>
          <h6>Monthly transport capacity [Relative to simulation start] </h6>
          <FaDownload onClick={handleCapacityDownload} style={{cursor: 'pointer'}}/>
          </div>
          
          <ResponsiveContainer width="100%" height={150}>
            <LineChart
              data={getCapacityData(overallData)}
              syncId="anyId"
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 5,
              }}
              ref={capacityRef}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" ticks={getXticks(overallData)} tick={<CustomizedAxisTick />}/>
              <YAxis />
              <Tooltip content={<CustomTooltip />} />
              <Line dataKey="Capacity" stroke="steelblue" strokeWidth={3} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
        :
        <div />
      }


      {charts[4].checked ?
        <div>
          <div className='d-flex flex-row justify-content-between w-100 align-items-center'>
          <h6>% of sailing ships [Relative to simulation start] </h6>
          <FaDownload onClick={handleShipsDownload} style={{cursor: 'pointer'}}/>
          </div>
          <ResponsiveContainer width="100%" height={150}>
            <LineChart
              data={getSailingShipData(overallData)}
              syncId="anyId"
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 5,
              }}
              ref={shipsRef}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" ticks={getXticks(overallData)} tick={<CustomizedAxisTick />}/>
              <YAxis />
              <Tooltip content={<CustomTooltip />} />
              <Line dataKey="Ships" stroke="steelblue" strokeWidth={3} dot={false} />
            </LineChart>
          </ResponsiveContainer>
         

        </div>
        :
        <div />
      }


      {charts[5].checked ?
        <div>
          <div className='d-flex flex-row justify-content-between w-100 align-items-center'>
          <h6>% of monthly bunker events [Relative to simulation start] </h6>
          <FaDownload onClick={handleBunkerDownload} style={{cursor: 'pointer'}}/>
          </div>
          <ResponsiveContainer width="100%" height={150}>
            <LineChart
              data={getBunkeringShipData(overallData)}
              syncId="anyId"
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 5,
              }}
              ref={bunkerRef}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" ticks={getXticks(overallData)} tick={<CustomizedAxisTick />}/>
              <YAxis />
              <Tooltip content={<CustomTooltip />} />
              <Line dataKey="Ships" stroke="steelblue" strokeWidth={3} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
        :
        <div />
      }

{charts[6].checked ?
        <div>
          <div className='d-flex flex-row justify-content-between w-100 align-items-center'>
          <h6>Monthly + cumulative capital expenditure [M€]</h6>
          <FaDownload onClick={handleCapexDownload} style={{cursor: 'pointer'}}/>
          </div>
          <ResponsiveContainer width="100%" height={150}>
            <LineChart
              data={getCapexData(overallData)}
              syncId="anyId"
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 5,
              }}
              ref={capexRef}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" ticks={getXticks(overallData)} tick={<CustomizedAxisTick />}/>
              <YAxis yAxisId="left" />
              <YAxis yAxisId="right" orientation="right" />
              <Tooltip content={<CustomTooltip />} />
              <Legend verticalAlign="top" align="right" height={36} />
              <Line yAxisId="left" dataKey="CAPEX" stroke="steelblue" strokeWidth={1} dot={false} />
              <Line yAxisId="right" dataKey="Cumulative CAPEX" stroke="red" strokeWidth={1} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
        :
        <div />
      }
      {charts[7].checked ?
  <div>
    <div className='d-flex flex-row justify-content-between w-100 align-items-center'>
    <h6>Monthly + cumulative operational expenditure [M€]</h6>
    <FaDownload onClick={handleOpexDownload} style={{cursor: 'pointer'}}/>
    </div>
    <ResponsiveContainer width="100%" height={150}>
      <LineChart
        data={getOpexData(overallData)}
        syncId="anyId"
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 5,
        }}
        ref={opexRef}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" ticks={getXticks(overallData)} tick={<CustomizedAxisTick />}/>
        <YAxis yAxisId="left" />
        <YAxis yAxisId="right" orientation="right" />
        <Tooltip content={<CustomTooltip />} />
        <Line yAxisId="left" dataKey="OPEX" stroke="steelblue" strokeWidth={1} dot={false} />
        <Line yAxisId="right" dataKey="Cumulative OPEX" stroke="red" strokeWidth={1} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  </div>
  :
  <div />
}
{charts[8].checked ?
  <div>
    <div className='d-flex flex-row justify-content-between w-100 align-items-center'>
    <h6>Monthly average speed [kn]</h6>
    <FaDownload onClick={handleSpeedDownload} style={{cursor: 'pointer'}}/>
    </div>
    <ResponsiveContainer width="100%" height={150}>
      <LineChart
        data={getSpeedData(overallData)}
        syncId="anyId"
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 5,
        }}
        ref={speedRef}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" ticks={getXticks(overallData)} tick={<CustomizedAxisTick />}/>
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Line dataKey="Speed" stroke="steelblue" strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  </div>
  :
  <div />
}
{charts[9].checked ?
  <div>
    <div className='d-flex flex-row justify-content-between w-100 align-items-center'>
    <h6>Total monthly electric energy demand [GWh] <InfoIcon text="The total monthly energy demand for electric energy carriers and the production of e-fuels" /></h6>
    <FaDownload onClick={handleElecDownload} style={{cursor: 'pointer'}}/>
    </div>
    <ResponsiveContainer width="100%" height={150}>
      <LineChart
        data={getElectricEnergyData(overallData)}
        syncId="anyId"
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 5,
        }}
        ref={elecRef}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" ticks={getXticks(overallData)} tick={<CustomizedAxisTick />}/>
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Line dataKey="Electric Energy" stroke="steelblue" strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  </div>
  :
  <div />
}

    </div>
  )
}

